import React from "react";

function CompanyEdit(props) {
  const { editable, handleEditButtonClick, isMobile } = props;

  return editable === true && (isMobile === true ? (
    <button type='button' className='btn btn-outline-primary btn-sm' onClick={handleEditButtonClick}>編集</button>
  ) : (
    <td id='cover-btn' className='d-none d-md-table-cell edit-btns'>
      <button type='button' className='btn btn-outline-light btn-m' onClick={handleEditButtonClick}>編集</button>
    </td>
  ));
}

export default CompanyEdit;
